export default "__VITE_ASSET__DrUzkkYJ__"